import { InjectionToken } from "@angular/core";

export const COMON_WEB_API = new InjectionToken<string>('API Base URL for all com&on custom requests');
